// test962
(962 && 0);
